<!-- //main container -->
<div
  class="container-fluid d-flex justify-content-center align-items-center min-vh-100 mt-10 mb-10 "style="background-image: linear-gradient(to top, #00c6fb 0%, #005bea 100%);"
>
  <!-- //signup container -->
  <div
    class="row bh-white shadow box-area box-shadow mt-2 mb-2"
    style="width: 82%"
  >
    <!-- //left box -->
    <div
      class="col-md-4 d-flex justify-content-center align-items-center flex-column left-box"
      style="background: #103cbe"
    >
      <h3 class="m-0 text-white">Welcome!</h3>

      <div class="featured-image mb-3">
        <img
          src="assets/signup-illustrator/Sign-up.png"
          class="img-fluid"
          style="width: 250px"
          loading="lazy"
        />
      </div>

      <p class="mb-0 text-white">
        Not a member yet?
        <a href="#!" class="text-white text-decoration-none">Register now</a>
      </p>
    </div>

    <!-- right box -->
    <div class="col-md-8 right-box" style="background: #ffffff">
      <div class="row">
        <div class="col-12">
          <div class="mb-2">
            <!-- <h3 class="display-1 fw-bold text-start text-pr ">Sign up</h3> -->
            <p class="text-center m-0 mt-3">
              Already have an account?
              <a
                routerLink="/auth/login"
                class="link-primary text-decoration-none"
                >Sign in</a
              >
            </p>
          </div>
        </div>

        <div class="input-group">
          <form
            [formGroup]="signupFormGroup"
            (ngSubmit)="signUpSubmit()"
            class="row g-3"
          >
            <!-- Account type -->
            <div class="col-md-12">
              <div class="form-floating">
                <select
                  class="form-select"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                >
                  <option selected>Choose...</option>
                  <option>Individual</option>
                  <option>Company</option>
                  <option>Education Institute</option>
                  <option>Non-profit Organization</option>
                  <option>Government Organization</option>
                </select>
                <label for="floatingSelect">Account Type</label>
              </div>
            </div>

            <!-- //Username -->
            <div class="col-md-6">
              <div class="input-field" [ngClass]="{'invalid-border':
                    signupFormGroup.controls.name.touched &&
                    signupFormGroup.controls.name.invalid
                }"
              >
                <div
                  class="form-floating"
                  [ngClass]="{
                    'is-invalid':
                      signupFormGroup.controls.name.touched &&
                      signupFormGroup.controls.name.invalid
                  }"
                >
                  <input
                    formControlName="name"
                    type="text"
                    class="form-control border-end-0"
                    id="username"
                    placeholder="Username"
                  />
                  <label for="username">Username</label>
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    signupFormGroup.controls.name.touched &&
                    signupFormGroup.controls.name.invalid
                  "
                >
                  <span *ngIf="signupFormGroup.controls.name.errors.required"
                    >This field is mandatory.</span
                  >
                  <span *ngIf="signupFormGroup.controls.name.errors.pattern"
                    >This field is invalid.</span
                  >
                </div>
              </div>
            </div>

            <!-- //Contact Number -->
            <div class="col-md-6">
              <div
                class="input-field"
                [ngClass]="{
                  'invalid-border':
                    signupFormGroup.controls.contactNumber.touched &&
                    signupFormGroup.controls.contactNumber.invalid
                }"
              >
                <div
                  class="form-floating"
                  [ngClass]="{
                    'is-invalid':
                      signupFormGroup.controls.contactNumber.touched &&
                      signupFormGroup.controls.contactNumber.invalid
                  }"
                >
                  <input
                    formControlName="contactNumber"
                    (input)="onInputChange($event)"
                    type="number"
                    class="form-control border-end-0"
                    id="contactnumber"
                    placeholder="Contact Number"
                  />
                  <label for="contactnumber">Phone no</label>
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    signupFormGroup.controls.contactNumber.touched &&
                    signupFormGroup.controls.contactNumber.invalid
                  "
                >
                  <span
                    *ngIf="
                      signupFormGroup.controls.contactNumber.errors.required
                    "
                    >Contact number is required.</span
                  >
                  <span
                    *ngIf="
                      signupFormGroup.controls.contactNumber.errors.pattern
                    "
                    >Enter a valid number with up to 10 digits.</span
                  >
                </div>
              </div>
            </div>

            <!-- //email -->
            <div class="col-md-12">
              <div
                class="input-field"
                [ngClass]="{
                  'invalid-border':
                    signupFormGroup.controls.email.touched &&
                    signupFormGroup.controls.email.invalid
                }"
              >
                <div
                  class="form-floating"
                  [ngClass]="{
                    'is-invalid':
                      signupFormGroup.controls.email.touched &&
                      signupFormGroup.controls.email.invalid
                  }"
                >
                  <input
                    formControlName="email"
                    type="email"
                    class="form-control border-end-0"
                    id="email"
                    placeholder="Email"
                  />
                  <label for="email">Email address</label>
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    signupFormGroup.controls.email.touched &&
                    signupFormGroup.controls.email.invalid
                  "
                >
                  <span *ngIf="signupFormGroup.controls.email.errors.required"
                    >Email is mandatory.</span
                  >
                  <span *ngIf="signupFormGroup.controls.email.errors.pattern"
                    >Invalid Email</span
                  >
                </div>
              </div>
            </div>

            <div class="col-md-6 input-field">
              <div
                class="input-group"
                [ngClass]="{
                  'invalid-border':
                    signupFormGroup.controls.password.touched &&
                    signupFormGroup.controls.password.invalid
                }"
              >
                <div
                  class="form-floating"
                  [ngClass]="{
                    'is-invalid':
                      signupFormGroup.controls.password.touched &&
                      signupFormGroup.controls.password.invalid
                  }"
                >
                  <input
                    formControlName="password"
                    [type]="password ? 'password' : 'text'"
                    type="password"
                    class="form-control border-end-0"
                    id="passwordStrong"
                    placeholder="Enter Password"
                  />
                  <label for="passwordStrong">Enter Password</label>
                </div>
                <div class="input-group-text border-start-0 bg-white">
                  <i
                    style="display: inline"
                    type="button"
                    (click)="password = !password"
                    [ngClass]="password ? 'fa fa-eye-slash' : 'fa fa-eye'"
                  ></i>
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    signupFormGroup.controls.password.touched &&
                    signupFormGroup.controls.password.invalid
                  "
                >
                  <span
                    *ngIf="signupFormGroup.controls.password.errors.required"
                    >This field is mandatory.</span
                  >
                  <span *ngIf="signupFormGroup.controls.password.errors.pattern"
                    >Password must be at least 8 characters long, contain at
                    least one uppercase letter, one lowercase letter,</span
                  >
                </div>
              </div>
            </div>

            <!-- Confirm Password -->

            <div class="col-md-6 input-field">
              <div
                class="input-group"
                [ngClass]="{
                  'invalid-border':
                    signupFormGroup.controls.confirmPassword.touched &&
                    signupFormGroup.controls.confirmPassword.invalid
                }"
              >
                <div
                  class="form-floating"
                  [ngClass]="
                    signupFormGroup.controls.confirmPassword.touched &&
                    signupFormGroup.controls.confirmPassword.invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                >
                  <input
                    formControlName="confirmPassword"
                    [type]="confirmPassword ? 'password' : 'text'"
                    type="password"
                    class="form-control border-end-0"
                    id="ConfirmPasswordStrong"
                    placeholder="Enter Password"
                  />
                  <label for="ConfirmPasswordStrong">Confirm Password</label>
                </div>

                <div class="input-group-text border-start-0 bg-white">
                  <i
                    style="display: inline"
                    type="button"
                    (click)="confirmPassword = !confirmPassword"
                    [ngClass]="
                      confirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                    "
                  ></i>
                </div>

                <div
                  class="invalid-feedback"
                  *ngIf="
                    signupFormGroup.controls.confirmPassword.touched &&
                    signupFormGroup.controls.confirmPassword.invalid
                  "
                >
                  <!-- <span *ngIf="signupFormGroup.controls.confirmPassword.errors.required">This field is mandatory.</span> -->
                  <!-- <span *ngIf="signupFormGroup.controls.confirmPassword.errors.pattern">This field is invalid.</span> -->
                </div>

                <div class="invalid-feedback">
                  <span
                    *ngIf="
                      validateSubmit() &&
                      signupFormGroup.controls.confirmPassword.invalid
                    "
                    >Password does not match</span
                  >
                </div>

                <div
                  class="valid-feedback"
                  *ngIf="
                    !validateSubmit() &&
                    !signupFormGroup.controls.confirmPassword.invalid
                  "
                >
                  <span>Password matched</span>
                </div>
              </div>
            </div>

            <!-- Address       -->
            <div class="col-md-12  input-field">
              <div class="form-floating mb-1">
                <input
                  type="text"
                  class="form-control"
                  id="address"
                  placeholder="address"
                />
                <label for="address">Address</label>
              </div>
            </div>

            <!-- dynamic class added button--loading for loading state -->
            <div class="col-md-12 mt-2">
              <button
                type="submit"
                [ngClass]="{ 'button--loading': isLoading }"
                [disabled]="signupFormGroup.invalid"
                class="btn btn-primary button--loading w-100"
              >
                <span class="button--text">Sign up</span>
              </button>
            </div>

            <div class="col-md-12 mt-2 mb-2">
              <button
                type="button"
                class="btn btn-secondary w-100"
                (click)="onReset()"
                [disabled]="isLoading"
              >
                Reset
              </button>
            </div>
          </form>
        </div>

        <!-- <div class="row mt-3">
          <div class="col-md-12">
            <div class="d-flex mb-4 gap-2 gap-sm-3 justify-content-center">
              <a
                href="#!"
                class="btn btn-outline-danger bsb-btn-circle bsb-btn-circle-2xl"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  class="bi bi-google"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"
                  />
                </svg>
              </a>
              <a
                href="#!"
                class="btn btn-outline-primary bsb-btn-circle bsb-btn-circle-2xl"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  class="bi bi-facebook"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
                  />
                </svg>
              </a>
              <a
                href="#!"
                class="btn btn-outline-dark bsb-btn-circle bsb-btn-circle-2xl"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  class="bi bi-apple"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z"
                  />
                  <path
                    d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
